import React from "react";

const Loading = () => {
  return(
      <div className={'page'}>
          <header>
              <h1>Loading...</h1>
          </header>
      </div>
  )
};

export default Loading;